import React from 'react';
import { CLIENT_URL } from '../../lib/host';

// Страница входа для сотрудников. Верстка по «Бумаге»
// (docs/redesign/2026-09-04-bumaga/, артборд «Вход · сотрудники»).
//
// До 19.08.2026 на этом домене жила клиентская витрина: описание услуги,
// тарифная сетка в рублях, порядок оплаты и возврата. Сотруднику всё это
// бесполезно — у него внутренние квоты, а не тариф за 4 500 ₽, — и он каждый
// день пролистывал чужой ценник, чтобы добраться до формы входа.
//
// Витрина осталась на клиентском домене, здесь только вход.
//
// 🪤 Подзаголовок в макете кончается словами «без тарифов и оплаты». Здесь он
// короче: тест этой страницы запрещает слово «тариф» в любом виде, потому что
// именно оно когда-то и было ценником. Смысл макета сохранён, буква — нет; это
// осознанно, а не недосмотр верстальщика.

export default function StaffEntryPage({ authSlot }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-paper-bg px-6 py-8">
      <div className="w-full max-w-[440px] flex flex-col gap-3">
        <div className="bg-paper-card rounded-[20px] p-8 flex flex-col gap-[18px]">
          <span className="inline-flex items-baseline font-display text-[16px] font-extrabold tracking-[-0.02em] text-paper-ink">
            <span className="font-normal">первый</span>
            <span className="inline-block w-[5px] h-[5px] mx-[2px] bg-paper-accent" />
            Бит
            <span className="ml-[10px] text-[12px]">
              Бит.<span className="text-paper-accent">Ньютон</span>
            </span>
          </span>

          <div>
            <h1 className="m-0 font-display text-[30px] font-extrabold tracking-[-0.035em] leading-[1.05] text-paper-ink">
              Вход для сотрудников
            </h1>
            <p className="mt-[10px] text-[14px] leading-[1.5] text-paper-ink-2">
              Расшифровка встреч и звонков, протокол, озвучка. Внутренние квоты, без оплаты.
            </p>
          </div>

          {authSlot}
        </div>

        {/* Без клиентского домена абзаца нет целиком: «Вы клиент?» без ссылки —
            вопрос без ответа. */}
        {CLIENT_URL && (
          <p className="text-center text-[13px] text-paper-ink-3">
            Вы клиент, а не сотрудник?{' '}
            <a href={CLIENT_URL} className="font-semibold text-paper-ink hover:text-paper-accent">
              Вход для клиентов →
            </a>
          </p>
        )}
      </div>
    </div>
  );
}
